<template>
  <div class="statistics">
    <template>
      <b-row class="mb-4">
        <b-col>
          <box class="d-flex p-3 align-items-center">
            <router-link :to="{ name: 'dashboard-logs' }">
              Logs
            </router-link>
          </box>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="4" sm="6" class="mb-4">
          <dashboard-widget
            title="Our impressions"
            :amount="stats.table.totals.impressions"
          />
        </b-col>
        <b-col md="4" sm="6" class="mb-4">
          <dashboard-widget
            title="Impressions"
            :amount="stats.table.totals.factImpressions"
          />
        </b-col>
        <b-col md="4" sm="6" class="mb-4">
          <dashboard-widget
            title="Profit"
            :amount="stats.table.totals.factProfit"
            :is-currency="true"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <div
            :class="{
              'mb-5': !isMobileLayout,
              'border-bottom-0': isMobileLayout
            }"
            class="statistics-filters"
          >
            <box
              :class="{
                'is-mobile-layout': isMobileLayout,
                'is-mobile-show': isMobileFiltersShow
              }"
              class="rounded-0 p-3 rounded-0 d-md-flex flex-wrap"
            >
              <div class="statistics-filters__field p-2">
                <div class="select">
                  <v-date-picker
                    :max-date="new Date()"
                    :theme-styles="$config.datepicker.base"
                    :input-props="{
                      class: 'form-control form-control-lg',
                      placeholder: 'Date',
                      autocomplete: 'off'
                    }"
                    v-model="form.date"
                  />
                </div>
              </div>
              <div class="statistics-filters__field p-2">
                <multi-select
                  :search="models.adnetworks > 9"
                  :select-options="models.adnetworks"
                  zero-text="All"
                  btn-label="Adnetworks"
                  size="lg"
                  v-model="form.adnetwork"
                />
              </div>
              <!-- <div class="statistics-filters__field p-2">
                <b-button
                  variant="primary"
                  v-b-tooltip
                  title="Refresh"
                  @click="refresh()"
                >
                  <svg-icon icon="reset" />
                </b-button>
              </div> -->
            </box>
          </div>
        </b-col>
      </b-row>
      <b-row class="mb-5">
        <b-col md="12">
          <box class="p-1 rounded-0 border-top">
            <line-chart
              v-if="!noData"
              show-legend
              :data="chartData"
              :time-formatter="timeFormatter"
              :loading="reportLoading"
            />
            <p v-else class="h1 text-center my-2">
              No data for selected filters
            </p>
          </box>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <b-table
            show-empty
            bordered
            responsive
            :items="stats.table.data"
            :fields="stats.table.fields"
          >
            <template slot="bottom-row" slot-scope="{ fields }">
              <td class="p-2" v-for="field in fields" :key="field.key">
                <strong>
                  {{ format(field.key, stats.table.totals[field.key]) }}
                </strong>
              </td>
            </template>
          </b-table>
        </b-col>
      </b-row>

      <button-fixed-mobile
        :show="isMobileLayout"
        @fixed-button:click="isMobileFiltersShow = !isMobileFiltersShow"
      >
        <svg-icon icon="cross" v-if="isMobileFiltersShow" />
        <svg-icon icon="filter" v-else />
      </button-fixed-mobile>
    </template>
  </div>
</template>

<script>
import cloneDeep from 'clone';
import isEqual from 'js-isequal';
import { saverMixin } from '@/utils/mixins.js';
import stats from './mixins/stats.js';
import get from 'lodash.get';
import DashboardWidget from '@/views/Dashboard/components/DashboardWidget.vue';

export default {
  mixins: [saverMixin, stats],

  components: {
    DashboardWidget
  },

  data() {
    return {
      formClone: {
        date: new Date(),
        adnetwork: []
      },
      form: {
        date: new Date(),
        adnetwork: []
      },
      models: {
        adnetworks: []
      },
      stats: {
        table: {
          sortBy: 'hour',
          sortDesc: false,
          totals: {},
          data: [],
          fields: [
            {
              key: 'hour',
              label: 'Time',
              sortable: true
            },
            {
              key: 'impressions',
              label: 'Our impressions',
              sortable: true,
              formatter: val => {
                return this.$numeral(val).format('0,00');
              }
            },
            {
              key: 'factImpressions',
              label: 'Impressions',
              sortable: true,
              tdClass: 'p-2',
              thClass: 'pt-2 pb-2 pr-5 pl-5',
              formatter: val => {
                return this.$numeral(val).format('0,00');
              }
            },
            {
              key: 'spent',
              label: 'Spent',
              sortable: true,
              formatter: val => {
                return this.$numeral(val).format('$ 0.00');
              }
            },
            {
              key: 'factReturns',
              label: 'Revenue',
              sortable: true,
              formatter: val => {
                return this.$numeral(val).format('$ 0.00');
              }
            },
            {
              key: 'planProfit',
              label: 'Profit prediction',
              sortable: true,
              formatter: val => {
                return this.$numeral(val).format('$ 0.00');
              }
            },
            {
              key: 'factProfit',
              label: 'Profit',
              sortable: true,
              formatter: val => {
                return this.$numeral(val).format('$ 0.00');
              }
            }
          ]
        }
      }
    };
  },

  computed: {
    noData() {
      return this.stats.table.data.length === 0 && !this.reportLoading;
    },
    chartData() {
      const chartData = [
        // {
        //   key: 'impressions',
        //   name: 'Our Impressions',
        //   data: []
        // },
        // {
        //   key: 'factImpressions',
        //   name: 'Impressions',
        //   data: []
        // },
        {
          key: 'factProfit',
          name: 'Profit',
          data: []
        }
        // {
        //   key: 'factReturns',
        //   name: 'Revenue',
        //   data: []
        // },
        // {
        //   key: 'planProfit',
        //   name: 'Profit prediction',
        //   data: []
        // },
        // {
        //   key: 'spent',
        //   name: 'Spent',
        //   data: []
        // }
      ];
      chartData.forEach(el => {
        el.data = this.stats.table.data.map(point => {
          const pointDate = new Date(this.form.date);
          pointDate.setHours(point.hour.slice(0, 2));
          pointDate.setMinutes(0);
          return [+pointDate, point[el.key]];
        });
      });

      return chartData;
    }
  },

  methods: {
    fetchTrades() {
      return this.$api.core
        .post('/trades', {
          method: 'trades'
        })
        .then(res => {
          if (res.error) return Promise.reject(res);
          return res;
        })
        .catch(res => {
          this.$notify('alert', {
            text: get(res, 'error.message') || 'Some thing went wrong',
            variant: 'danger',
            time: 5000
          });
          return res;
        })
        .finally(() => {
          this.reportLoading = false;
        });
    },
    fetchReport() {
      if (!this.form.adnetwork[0]) return;
      this.reportLoading = true;
      return this.$api.core
        .post('/report', {
          method: 'report',
          params: {
            date: this.$date.format(this.form.date, 'YYYY-MM-DD'),
            banner: this.form.adnetwork[0].id
          }
        })
        .then(res => {
          if (res.error) return Promise.reject(res);
          const transform = obj => {
            const date = new Date(this.form.date);

            if (typeof obj.hour === 'number') {
              date.setHours(obj.hour);
              date.setMinutes(0);
            }

            return {
              hour:
                obj.hour || obj.hour === 0
                  ? this.$date.format(date, 'HH:mm')
                  : 'Summary',
              impressions: obj.impressions,
              factImpressions: obj.fact_impressions,
              factProfit: obj.fact_profit,
              factReturns: obj.fact_returns,
              planProfit: obj.plan_profit,
              spent: obj.spent
            };
          };

          this.stats.table.totals = transform(res.result);
          this.stats.table.data = res.result.by_hours.map(transform);

          return res;
        })
        .catch(res => {
          this.$notify('alert', {
            text: get(res, 'error.message') || 'Some thing went wrong',
            variant: 'danger',
            time: 5000
          });
          return res;
        })
        .finally(() => {
          this.reportLoading = false;
        });
    },
    format(key, val) {
      switch (key) {
        case 'factProfit':
        case 'factReturns':
        case 'planProfit':
        case 'spent':
          return this.$numeral(val).format('$ 0.00');
        case 'impressions':
        case 'factImpressions':
          return this.$numeral(val).format('0,00');
        default:
          if (typeof val === 'object' && val !== null) {
            return val.formatted || val.value;
          }
          return val;
      }
    },
    timeFormatter({ value }) {
      return this.$date.format(new Date(value), 'HH:mm');
    },
    statsPoller() {
      if (this.$route.path !== '/dashboard') return;
      clearTimeout(this.timer);
      this.timer = setTimeout(async () => {
        if (this.models.adnetworks.length !== 0) {
          await this.fetchReport();
        }
        this.statsPoller();
      }, 5000);
    },
    refresh() {
      if (this.models.adnetworks.length !== 0) {
        this.fetchReport();
      }
    },
    async initPage() {
      const trades = await this.fetchTrades();
      if (!trades) return Promise.reject(trades);

      this.models.adnetworks = trades.result.map(trade => {
        return {
          name: trade.title,
          id: trade.banner_id
        };
      });

      // TODO: очень мать его времено( хз в чем беда
      setTimeout(() => {
        if (this.form.adnetwork.length === 0) {
          this.form.adnetwork = [this.models.adnetworks[0]];
        }
      }, 1);

      return Promise.resolve(true);
    }
  },

  watch: {
    form: {
      deep: true,
      async handler(val) {
        if (isEqual(val, this.formClone)) return;
        this.formClone = cloneDeep(this.form);
        if (this.form.adnetwork.length !== 0) {
          clearTimeout(this.timer);
          await this.fetchReport();
          this.statsPoller();
        }
      }
    }
  }
};
</script>
